<template>
  <span
    :class="[
      'common-tab text-decoration-none',
      renderActiveClassName,
      customClassName ? customClassName : ''
    ]"
    @click="$emit('handleClick', label)"
    >{{ label }}</span
  >
</template>

<script>
import { ACADEMY_PREFIX, Routes } from "@/router/Routes";
import { i18n } from "@/plugins/i18n";

export default {
  name: "AssignmentsAndFilesNavigationLink",
  props: {
    label: {
      type: String,
      required: true
    },
    customClassName: {
      type: String,
      default: ""
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    renderActiveClassName() {
      if (this.isActive) {
        return "common-tab--active";
      } else if (
        (this.label === i18n.tc("storage.files") &&
          this.$route.path.includes(`${ACADEMY_PREFIX}/storage`)) ||
        (this.label === i18n.tc("storage.assignments") &&
          this.$route.path.includes(`${ACADEMY_PREFIX}/assignment`))
      ) {
        return "common-tab--active";
      }
      return "common-tab--inactive";
    }
  }
};
</script>

<style scoped>
.common-tab {
  font-size: 0.9rem;
  cursor: pointer;
  font-weight: 600;
}

.common-tab:nth-child(1) {
  padding-right: 16px;
}

.common-tab:not(:nth-child(1)) {
  padding-left: 16px;
  border-left: 1px solid var(--divider-color);
}

.common-tab--active {
  color: var(--primary-color);
}

.common-tab--inactive {
  color: var(--dark-color);
}
</style>
